var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeart120 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.986,
    height: 22.392,
    viewBox: "0 0 24.986 22.392",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M12.493,22.392a1.459,1.459,0,0,1-.966-.366c-1.009-.889-1.983-1.725-2.841-2.462l0,0a53,53,0,0,1-6.2-5.865A9.4,9.4,0,0,1,0,7.564,7.9,7.9,0,0,1,1.982,2.191,6.7,6.7,0,0,1,6.98,0a6.256,6.256,0,0,1,3.926,1.365,8.065,8.065,0,0,1,1.587,1.669A8.066,8.066,0,0,1,14.08,1.365,6.256,6.256,0,0,1,18.006,0a6.7,6.7,0,0,1,5,2.191,7.9,7.9,0,0,1,1.982,5.373A9.4,9.4,0,0,1,22.508,13.7a52.993,52.993,0,0,1-6.2,5.865c-.86.738-1.835,1.575-2.846,2.466a1.46,1.46,0,0,1-.966.365ZM6.98,1.474A5.254,5.254,0,0,0,3.058,3.191,6.426,6.426,0,0,0,1.463,7.564,7.913,7.913,0,0,0,3.6,12.755a52.153,52.153,0,0,0,6.026,5.684l0,0c.862.74,1.839,1.579,2.856,2.474,1.023-.9,2-1.737,2.865-2.478a52.166,52.166,0,0,0,6.025-5.683,7.913,7.913,0,0,0,2.141-5.191,6.426,6.426,0,0,0-1.595-4.373,5.253,5.253,0,0,0-3.922-1.716,4.832,4.832,0,0,0-3.031,1.057A7.14,7.14,0,0,0,13.286,4.5a.92.92,0,0,1-1.587,0A7.134,7.134,0,0,0,10.01,2.531,4.832,4.832,0,0,0,6.98,1.474Zm0,0",
    transform: "translate(0 0)",
    fill: "#0D47A1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeart120, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heart1-20.ece6b1ea.svg";
export { ForwardRef as ReactComponent };